import styled from "styled-components";
import Colors from "colors";
import Screens from "screens";

export default styled.div`
  padding: 3vw 6vw 3vw 6vw;

  .box {
    width: 50%;
    margin-left: auto;
    margin-right: auto;
    padding: 30px;
    @media ${Screens.mobile}, ${Screens.tablet} {
      width: 100%;
      margin-top: 20px;
    }

    .panel {
      margin-left: auto;
      margin-right: auto;
      .recaptcha {
        margin-top: 20px;
      }
      .success {
        color: ${Colors.green};
        margin-bottom: 15px;
      }
      .error {
        color: ${Colors.redDark};
        margin-bottom: 15px;
      }
    }
  }
`;
